import React from 'react';
import { View } from 'react-native';
import Svg, { Circle } from 'react-native-svg';

import ColorWrapper from '@styles/colors';

import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { ColorFunction } from '@styles/colors/types';

export interface ProductionOperationTimeChartProps {
  progress?: number;
  size: number;
  mainBgColor: string;
  secondaryBgColor: string;
  scale: ScaleFunction;
  C: ColorFunction;
}

const ProductionOperationTimeChart: React.FC<ProductionOperationTimeChartProps> = ({
  progress = 0,
  size = 18,
  scale,
  mainBgColor,
  secondaryBgColor,
  C,
}) => {
  const clampedProgress = Math.min(1, Math.max(0, progress));
  const radius = 50;
  const strokeWidth = 100;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference * (1 - clampedProgress);

  const overflowDashOffset = progress > 0 ? circumference * (2 - progress) : 0;

  if (progress <= 0) {
    return (
      <Svg width={size} height={size}>
        <Circle
          cx={size / 2}
          cy={size / 2}
          r={(size * 0.9) / 2}
          stroke={C('Label/Light/Quinary')}
          strokeWidth={scale(size / 10)}
          strokeDasharray={[5.625000476837158, 1.125]}
          fill="none"
        />
      </Svg>
    );
  }

  const showBorder = progress > 0 && progress < 1;

  return (
    <View
      style={{
        width: scale(size),
        height: scale(size),
        borderRadius: '50%',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <Svg width="100%" height="100%" viewBox="0 0 100 100">
        <Circle
          cx="50"
          cy="50"
          r={radius}
          fill="transparent"
          stroke={C(mainBgColor)}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          transform="rotate(-90, 50, 50)"
        />
        {showBorder && (
          <Circle cx="50" cy="50" r={radius} fill="none" stroke={C(mainBgColor)} strokeWidth={scale(size)} transform="rotate(-90, 50, 50)" />
        )}
        {progress > 1 ? (
          <Circle
            cx="50"
            cy="50"
            r={radius}
            fill="transparent"
            stroke={C(secondaryBgColor)}
            strokeWidth={strokeWidth}
            strokeDasharray={circumference}
            strokeDashoffset={overflowDashOffset}
            transform="rotate(-90, 50, 50)"
          />
        ) : null}
      </Svg>
    </View>
  );
};

export default ColorWrapper(ProductionOperationTimeChart);
